module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/pxiEyp8kv8JHgFVrJJfecnFHGPc.6f671f97.woff";